import React from 'react'
import Struktur from "../../assets/strukturBaznas.svg"

function StrukturBaznas () {
  return (
    <div id='sturktur' className=''>
    <h1 className='text-3xl font-bold text-primary pb-2 mb-1'>STRUKTUR BAZNAS KAB. BANYUMAS</h1>
    <img src={Struktur} className=""/>
</div>
  )
}

export default StrukturBaznas;